import api from "./axios";

export const getBookingsReportApi = (params) =>
  api.get("/reports/bookings", { params });

export const getSourceReportApi = (params) =>
  api.get("/reports/source", { params });

export const getPaymentsReportApi = (params) =>
  api.get("/reports/payments", { params });

export const getEmployeeCallsReportApi = (params) =>
  api.get("/reports/employee-calls", { params });

// Employee performance metrics
export const getEmployeePerformanceApi = (params) =>
  api.get("/employee-performance", { params });

export const getEmployeeDetailedMetricsApi = (employeeId, params) =>
  api.get(`/employee-performance/${employeeId}`, { params });

// Employee goals
export const getEmployeeGoalsApi = (employeeId) =>
  api.get(`/employee-goals/${employeeId}`);

export const updateEmployeeGoalsApi = (employeeId, data) =>
  api.put(`/employee-goals/${employeeId}`, data);
